enum TechPartnerRoute {
	PAGE_CREATE = '/pages/create',
	AD_FORMAT_CREATE = '/ad-formats/create'
}

export default TechPartnerRoute;
